exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".poster___poster___YUY6n {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity 1s linear;\n    background-size: cover;\n}\n\n.poster___poster--shown___1_NIk {\n    opacity: 1;\n}\n", ""]);

// exports
exports.locals = {
	"poster": "poster___poster___YUY6n",
	"poster--shown": "poster___poster--shown___1_NIk",
	"posterShown": "poster___poster--shown___1_NIk"
};